import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export const IMPERSONATION_BANNER_HEIGHT = 36;

export function ImpersonationBanner() {
  const { user, isImpersonating, impersonatorName, endImpersonation } = useAuth();
  const { t } = useTranslation('admin');
  const navigate = useNavigate();

  const handleEnd = () => {
    const returnUrl = endImpersonation();
    if (returnUrl) navigate(returnUrl);
    else navigate('/');
  };

  if (!isImpersonating) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: IMPERSONATION_BANNER_HEIGHT,
        zIndex: (theme) => theme.zIndex.appBar + 2,
        bgcolor: 'warning.main',
        color: 'warning.contrastText',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        px: 2,
      }}
    >
      <Typography variant="body2" fontWeight="bold">
        {t('impersonation.banner')}:&nbsp;
        {t('impersonation.actingAs', { name: user?.name ?? '' })}
        &nbsp;&mdash;&nbsp;
        {t('impersonation.by', { name: impersonatorName ?? '' })}
      </Typography>
      <Button size="small" variant="outlined" color="inherit" onClick={handleEnd}>
        {t('impersonation.end')}
      </Button>
    </Box>
  );
}
